import { render, staticRenderFns } from "./VenueSelection.vue?vue&type=template&id=4592697f&"
import script from "./VenueSelection.vue?vue&type=script&lang=js&"
export * from "./VenueSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports